import lodash from "lodash"
import { getXPathMapping } from "@/MetadataRules/MetadataRulesDataService"
import * as mutations from "./constants/mutation-types"
import * as getters from "./constants/getter-types"
import * as actions from "./constants/action-types"

export const metadataRules = {
  namespaced: true,
  state: {
    ruleSetRulesList: [],
    ruleCollectionRuleSetsList: [],
    addRulesFilters: {},
    addRuleSetsFilters: {},
    ruleQuickView: false,
    ruleCollectionRuleSets: [],
    xpathMappings: []
  },
  mutations: {
    [mutations.SET_RULESET_RULES](state, value) {
      // added sequence for the rules
      lodash.forEach(value, (rule, index) => {
        rule["sequence"] = index
      })
      state.ruleSetRulesList = value
    },
    [mutations.SET_RULECOLLECTION_RULESETS](state, value) {
      // added sequence for the ruleSets
      lodash.forEach(value, (ruleSet, index) => {
        ruleSet["sequence"] = index
      })
      state.ruleCollectionRuleSetsList = value
    },
    [mutations.SET_ADD_RULES_FILTERS](state, value) {
      state.addRulesFilters = value
    },
    [mutations.SET_ADD_RULE_SETS_FILTERS](state, value) {
      state.addRuleSetsFilters = value
    },
    [mutations.SET_XPATH_MAPPINGS](state, xpathMappingsInput) {
      state.xpathMappings = xpathMappingsInput
    },
    [mutations.SET_RULE_QUICK_VIEW](state, value) {
      state.ruleQuickView = value
    }
  },
  actions: {
    [actions.GET_XPATH_MAPPINGS](context, queryObject) {
      return new Promise(resolve => {
        getXPathMapping(
          queryObject,
          context.rootGetters.RULE_MGMT_DATA_SERVICE_URL
        ).then(response => {
          context.commit(mutations.SET_XPATH_MAPPINGS, response.data.entries)
          resolve()
        })
      })
    }
  },
  getters: {
    [getters.RULE_SET_HAS_RULES](state) {
      if (!lodash.isUndefined(state.ruleSetRulesList)) {
        return state.ruleSetRulesList.length > 0
      } else {
        return false
      }
    },
    [getters.RULE_COLLECTION_HAS_RULES_SETS](state) {
      if (!lodash.isUndefined(state.ruleCollectionRuleSetsList)) {
        return state.ruleCollectionRuleSetsList.length > 0
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/metadataRules.js